const REACT_STACK_PROBE_MESSAGES = new Set(['pa', 'La', 'Ka', 'Ka`prod']);
const FILTER_FLAG = '__retailgoReactStackProbeFilter';

function messageText(value) {
  if (typeof value === 'string') {
    return value;
  }
  if (value && typeof value.message === 'string') {
    return value.message;
  }
  return '';
}

export function isReactStackProbeLeak(value) {
  const text = messageText(value).replace(/^Error:\s*/, '').trim();
  return REACT_STACK_PROBE_MESSAGES.has(text);
}

export function installReactStackProbeErrorFilter(target = typeof window !== 'undefined' ? window : null) {
  if (!target || typeof target.addEventListener !== 'function' || target[FILTER_FLAG]) {
    return false;
  }

  const ignoreLeak = (event, ...values) => {
    if (!values.some(isReactStackProbeLeak)) {
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  target.addEventListener('error', (event) => {
    // Chrome on iPhone can leave the probe text on event.message while
    // event.error is a truthy Error with an empty or unrelated message.
    ignoreLeak(event, event.message, event.error);
  }, true);

  target.addEventListener('unhandledrejection', (event) => {
    ignoreLeak(event, event.reason);
  }, true);

  Object.defineProperty(target, FILTER_FLAG, {
    value: true,
    enumerable: false,
  });

  return true;
}
